<script setup lang="ts">
import { useRegisterSW } from 'virtual:pwa-register/vue'

const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW({
  onOfflineReady() {
    // console.log('App ready to work offline')
  },
})

const close = async () => {
  offlineReady.value = false
  needRefresh.value = false
}

// Auto update when refresh needed (optional, or stick to manual)
// watch(needRefresh, (value) => {
//   if (value) updateServiceWorker()
// })
</script>

<template>
  <div
    v-if="offlineReady || needRefresh"
    class="fixed bottom-20 left-4 right-4 z-50 p-4 bg-slate-800 dark:bg-slate-900 text-white rounded-xl shadow-xl border border-slate-700 dark:border-slate-800 flex flex-col gap-2"
    role="alert"
  >
    <div class="flex items-start gap-3">
      <div class="p-2 bg-primary/20 rounded-lg text-primary-400">
        <svg v-if="needRefresh" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 16h5v5"/></svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
      </div>
      <div>
        <h3 class="font-bold text-sm mb-1">
          {{ needRefresh ? 'Versi Baru Tersedia' : 'Siap Offline' }}
        </h3>
        <p class="text-xs text-slate-300 dark:text-slate-400">
          {{ needRefresh ? 'Klik tombol perbarui untuk mendapatkan fitur terbaru.' : 'Aplikasi siap digunakan tanpa internet.' }}
        </p>
      </div>
    </div>
    
    <div class="flex gap-2 mt-2">
      <button
        v-if="needRefresh"
        @click="updateServiceWorker()"
        class="flex-1 py-2 px-3 bg-primary hover:bg-primary-600 text-white text-sm font-medium rounded-lg transition-colors"
      >
        Perbarui Sekarang
      </button>
      <button
        @click="close"
        class="flex-1 py-2 px-3 bg-slate-700 hover:bg-slate-600 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-200 text-sm font-medium rounded-lg transition-colors"
      >
        Tutup
      </button>
    </div>
  </div>
</template>
